import { createSlice } from '@reduxjs/toolkit'

import {
  initialReferralsImportState,
  reducers,
  ReferralsImportState,
} from '@/redux/slices/referralsImportBase'
import { RootState } from '@/redux/store'

const INITIAL_STATE: ReferralsImportState = {
  ...initialReferralsImportState,
}

const referralsImportHistorical = createSlice({
  name: 'referralsImportHistorical',
  initialState: INITIAL_STATE,
  reducers,
})

export const referralsImportHistoricalReducer =
  referralsImportHistorical.reducer

export const selectReferralsImportHistorical = (state: RootState) =>
  state.referralsImportHistorical

export const {
  setIsOpen,
  setShowImported,
  setImportItems,
  updateImportItem,
  removeImportItem,
  setStep,
  setOnClientDuplicate,
  updateImportItemStatus,
  selectItems,
  bulkUpdateImportItems,
} = referralsImportHistorical.actions
